import React from "react";
import {scrollToElement} from "../../helpers/functions";
import {Loader, Button, Alert, Table, Heading} from "arag-ui-lib";
import CONTENT_STRINGS from "../../helpers/contentStrings";
import {DOTS, MEDIUM, RIGHT, PRIMARY, SUCCESS, ERROR, HEADING_2} from "../../helpers/constants";
import {handleEditingSettingsColumns} from "../../helpers/utilFunctions";
import {buildEditingSettingsTableData} from "../../helpers/editingSettingsFunctions";


const EditingSettings = (props) => {
    const {
        questions,
        editingSettings,
        editingSettingsValues,
        changeEditingSettings,
        editingSettingsOptions,
        fetchingQuestions,
        getFieldFormEditingSetting,
        handleSaveChanges,
        fetchingEditingSettingsEditableByOptions,
        fetchingEditingSettings,
        updating,
        updateErrorMessage,
        updateSuccessMessage,
        getEditingSettingFromTableName,
        getEditingSettingFromColumnName
    } = props;

    const isLoading = (
        fetchingEditingSettingsEditableByOptions
        || fetchingEditingSettings
        || fetchingQuestions
    );

    let wrapperEl = null;

    let onSaveChanges = () => {
        if(wrapperEl){
            scrollToElement(wrapperEl, {left: 0, top: wrapperEl.offsetTop});
        }

        handleSaveChanges();
    }

    const editingSettingsTableColumns = handleEditingSettingsColumns(
        questions, 
        changeEditingSettings, 
        editingSettingsOptions, 
    );

    const editingSettingsTableData = buildEditingSettingsTableData({
        questions,
        editingSettings,
        editingSettingsValues,
        getFieldFormEditingSetting,
        getEditingSettingFromTableName,
        getEditingSettingFromColumnName,
    });
    
    // ensure responsive design by using accordion headers for rows in smaller screens
    const AccordionHeader = (row) => <div>{`${row.question.name}`}</div>;

    return (
        <div ref={(el) => { wrapperEl = el; }} >
            <div className="row">
                <div className={"col-sm-12"}>
                    <Heading 
                        variant={HEADING_2} 
                        title={CONTENT_STRINGS.EDITING_SETTINGS} 
                        headingTestId={'editing-settings-header'} 
                    />
                </div>
                {updating ? (
                    <div className={"col-sm-12"}>
                        <Loader variant={DOTS} dotSize={MEDIUM}/>
                    </div>
                ) : null}
                {updateErrorMessage ? (
                    <div className={"col-sm-12"}>
                        <Alert 
                            variant={ERROR} 
                            label={updateErrorMessage} 
                            alertTestId="editing-settings-error" 
                        />
                    </div>
                ) : null}
                {updateSuccessMessage ? (
                    <div className={"col-sm-12"}>
                        <Alert 
                            variant={SUCCESS} 
                            label={updateSuccessMessage} 
                            alertTestId="editing-settings-success" 
                        />
                    </div>
                ) : null}
                {isLoading ? (
                        <div className={"col-sm-12"}>
                            <Loader variant={DOTS} dotSize={MEDIUM}/>
                        </div>
                    ) : (
                        <div className={"col-sm-12"}>
                            <Table
                                columns={editingSettingsTableColumns}
                                data={editingSettingsTableData}
                                striped
                                accordionItemHeaderFormatter={AccordionHeader}
                                tableWrapperTestId={"editing-settings-table"} 
                            />
                            <div className="btn-fab">
                                <Button 
                                    variant={PRIMARY}
                                    label={CONTENT_STRINGS.SAVE_CHANGES}
                                    arrowDirection={RIGHT}
                                    onClick={onSaveChanges}
                                    buttonTestId="editing-settings-save-button" 
                                />
                            </div>
                        </div>
                    )
                }            
            </div>
        </div>
    )
};

export default EditingSettings;